// extracted by mini-css-extract-plugin
export var infoItem = "_ne-2";
export var title = "_ne-0";
export var value = "_ne-1";